import React from 'react';
import { Link } from 'react-router-dom';
import { Divider, Flex, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { useGetContact } from 'api/contacts/use-get-contact.ts';
import { useFindCountry } from 'shared/hooks/use-find-country.ts';
import { ClientDescription } from 'components/clients/client-description';
import { ClientFactoringTag } from 'components/clients/client-factoring-tag';
import { ClientTypeTag } from 'components/clients/client-type-tag';
import { CardUi } from 'components/common/card-ui';
import type { IClientInfoCardProps } from './types';

export const ClientInfoCard: React.FC<IClientInfoCardProps> = (props) => {
  const { client, contact, contactId, className } = props;
  const country = useFindCountry(client?.legalCountryId);

  const { data: contactFromApi, isLoading } = useGetContact(contactId);

  const contactData = contactFromApi ? contactFromApi : contact;

  return (
    <CardUi className={className} loading={isLoading && Boolean(contactId)}>
      <Flex align='start' gap='small' vertical>
        <Flex gap='small' justify='space-between' align='start'>
          <Typography.Text strong>
            {client.name}{' '}
            <Link to={`/clients/${client.id}`}>
              <LinkOutlined />
            </Link>
          </Typography.Text>
          <Flex gap='small'>
            <ClientTypeTag type={client.type} isVip={client.isVip} />
            {client.factoringEnabled ? <ClientFactoringTag /> : null}
          </Flex>
        </Flex>
        {client.vatNumber ? (
          <div>
            <strong>VAT:</strong> {client.vatNumber}
          </div>
        ) : null}
        <div>
          <strong>Address: </strong>
          {country ? (
            <Typography.Text italic>
              ({country.code}) {country.name} -{' '}
            </Typography.Text>
          ) : null}
          {client.legalPostCode ? <Typography.Text italic>{client.legalPostCode} - </Typography.Text> : null}
          {client.legalAddress ? <Typography.Text italic>{client.legalAddress}</Typography.Text> : null}
        </div>
        {client.description ? (
          <div>
            <strong>Description: </strong> <ClientDescription description={client.description} />
          </div>
        ) : null}
      </Flex>
      <Divider />
      <Flex align='start' vertical>
        <Flex gap='small'>
          <Typography.Text strong>{contactData?.name}</Typography.Text>{' '}
          <Typography.Text type='secondary'>{contactData?.role}</Typography.Text>
        </Flex>
        <div>{contactData?.phone}</div>
        <Typography.Text strong>{contactData?.email}</Typography.Text>
      </Flex>
    </CardUi>
  );
};
